module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "buttonStyle": "primary",
      "heading": _vm.utilLabel + ' Bill',
      "showText": _vm.showText,
      "buttonText": _vm.utilLabel + ' Bill',
      "disableButton": !_vm.canAccess('finance|admin') || _vm.readOnly,
      "buttonIcon": "fa fa-plug"
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('utility-bill-details', {
    ref: "ubill",
    attrs: {
      "site-data": _vm.siteData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46afe8f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/UtilityBillAction.vue
// module id = 1457
// module chunks = 0